import React from 'react';
import PropTypes from 'prop-types';

import MuiDivider from '@material-ui/core/Divider';
import { useDividerStyles } from './dividerStyles';

/**
 * Custom Divider component based on https://material-ui.com/components/dividers/#divider
 * @param {} props All possible props can be found in docs https://material-ui.com/api/divider/
 */
export default function Divider(props) {
  const { orientation, ...rest } = props;
  const classes = useDividerStyles(props);
  return (
    <MuiDivider
      className={classes[orientation]}
      orientation={orientation}
      {...rest}
    />
  );
}

Divider.propTypes = {
  /** Orientation of the divider */
  orientation: PropTypes.string.isRequired,
  /** Divider width */
  width: PropTypes.string,
  /** Divider height of the divider */
  height: PropTypes.string,
  /** Color of the divider */
  color: PropTypes.string,
};
